var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMissingCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 23.0027C5 23.0027 6.35996 22.8546 8.60862 20.8483C13.1194 16.8088 19.2056 7.51795 19.2056 7.51795C19.2056 7.51795 20.1212 6.0368 21.2253 5.98294C22.3294 5.92908 25.7361 5.79443 25.7361 5.79443L21.6697 23.0431C21.6697 23.0296 6.48115 23.0296 5 23.0027Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissingCarrier);
export default __webpack_public_path__ + "static/media/icon-missing-carrier.886fec15bdc2909b0a0e8512517d69aa.svg";
export { ForwardRef as ReactComponent };